export default __webpack_public_path__ + "static/media/telugu_general_f.a6035f4d.wav";